module.exports = __webpack_public_path__ + "img/w7-cover.8fcf681a.jpg";